import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { CommonTabCardProp } from "../../../../Types/BookmarkType";
import SearchNotFoundClass from "../../../CommonComponents/SearchNotFound/SearchNotFoundClass";
import ViewBookmark from "../ViewBookmarks";

const CommonTabCard: React.FC<CommonTabCardProp> = ({ tabId, title }) => {
  return (
    <TabPane tabId={tabId}>
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <H4 className="mb-0">{title}</H4>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <SearchNotFoundClass word="Bookmark" />
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default CommonTabCard;
